/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
const ORGANIZATION_IDS = {
  KAO: process.env.REACT_APP_BACKDOOR_ORGANIZATION_ID,
} as const;

export const isBackdoorEnabled = () =>
  process.env.NODE_ENV === "development" &&
  process.env.REACT_APP_BACKDOOR === "enabled";

export const getOrganizationId = () => ORGANIZATION_IDS.KAO;

export const getEmployeeId = () => {
  switch (getOrganizationId()) {
    case ORGANIZATION_IDS.KAO:
      return 10582810; // 広島の人1 (21117)
    // return 10578784 // 広島の人2 (20532)
    // return 10553404 // 広島の人3
    // return 10311402 // 新百合ヶ丘の人
    // return 10544214 // ひばりヶ丘の人
    // return 10317075 // 秦野の人
    // return 10542399 // 日本橋の人
    // return 10311326 // 茅ヶ崎の人
    // return 10328662 // 京都の人
    // return 10576378 // 新曳舟の人
    // return 10992633 // 練馬の人
    // return 10578142 // 渋谷の人
    // return 10549140 // 10582810のauthorizer
    default:
      return 0;
  }
};
/* eslint-enable */
